<template>
    <div v-if="totalsData" class="row mr-0">
      <div class="col-lg-3 col-md-6 col-12 mt-4 mt-lg-0 pr-md-2 pr-lg-4 " v-if="!this.campaignWithOutBags">
          <div class="card text-center p-3 " style="border:1px solid #ddd;">
            <h4 class="text-dark">{{ totalsData.quantityDistributedBagAsString }} <span class="font-weight-normal font-size-14"> / {{ totalsData.quantityBagAsString }}</span></h4>
            <p class="text-uppercase text-dark font-weight-bold">{{ $t('campaign.card.totalDistributed') }}</p>
          </div>
        </div>
        <div class="col-lg-3 col-md-6 col-12 mt-4 mt-lg-0 pr-md-2 pr-lg-4 pl-lg-4" v-if="!this.campaignWithOutBags">
          <div class="card text-center p-3 " style="border:1px solid #ddd;">
            <h4 class="text-info">{{ totalsData.visibilityAsString ? '+ ' + totalsData.visibilityAsString : '' }}</h4>
            <p class="text-uppercase text-dark font-weight-bold">{{ $t('campaign.card.visibility') }}</p>
          </div>
        </div>
        <div class="mt-4 mt-lg-0" :class="this.campaignWithOutBags ? 'col-md-6 col-12 pr-lg-4': 'col-lg-3 col-md-6 col-12 mt-4 mt-lg-0 pr-md-2 pr-lg-4 pl-lg-4'">
          <div class="card text-center p-3" style="border:1px solid #ddd;">
              <h4 class="text-primary">{{ totalsData.totalScanAsString }}</h4>
              <p class="text-uppercase text-dark font-weight-bold">{{ $t('campaign.card.totalScan') }}</p>
            </div>
        </div>
        <div class="mt-4 mt-lg-0" :class="this.campaignWithOutBags ? 'col-md-6 col-12 pl-lg-4': 'col-lg-3 col-md-6 col-12 pl-md-2 pl-lg-4'">
          <div class="card text-center p-3" style="border:1px solid #ddd;">
              <h4  class="text-primary">{{ totalsData.totalScanUniqueAsString ? totalsData.totalScanUniqueAsString : '-' }}</h4>
              <p class="text-uppercase text-dark font-weight-bold">{{ $t('campaign.card.totalScanUnique') }}</p>
            </div>
        </div>
      
  

  
        
    </div>
  </template>
  
  <script>
  import Vue from 'vue';
  import VueApexCharts from 'vue-apexcharts';
  
  Vue.component('apexchart', VueApexCharts);
  
  export default {

    props: {
      campaignWithOutBags: {
            type: Boolean,
            default: false,
          },
      totalsData: {
            type: Object,
            default: () => null,
          },
    },

    data() {
      return {
        series1: [
          {  data: [53, 68, 75, 120, 85, 102, 43] },
        ],
        series2: [
          {  data: [40, 60, 70, 85, 73, 90, 43] },
        ],
        series3: [
          { data: [32, 44, 61, 77, 55, 80, 47] },
        ],
        chartOptions1: {},
        chartOptions2: {},
        chartOptions3: {},
      };
    },
    mounted() {
      this.renderSparkline1();
      this.renderSparkline2();
      this.renderSparkline3();
    },
    methods: {
      formatNumber(num) {
        return num.toLocaleString();
      },
      renderSparkline1() {
        this.chartOptions1 = this.getSparklineOptions();
      },
      renderSparkline2() {
        this.chartOptions2 = this.getSparklineOptions();
      },
      renderSparkline3() {
        this.chartOptions3 = this.getSparklineOptions();
      },
      getSparklineOptions() {
  return {
    chart: {
      type: 'line',
      height: 100,
      sparkline: { enabled: true },
      toolbar: {
        show: false, 
      }
    },
    stroke: {
      curve: 'smooth',
      width: 2,
    },
    tooltip: {
      enabled: true,
    },
    xaxis: {
      type: 'datetime',
      categories: [
        '2024-09-12',
        '2024-09-13',
        '2024-09-14',
        '2024-09-15',
        '2024-09-16',
        '2024-09-17',
        '2024-09-18',
      ],
      tooltip: {
        enabled: false,
      },
      labels: {
        show: false,
      },
      axisBorder: {
        show: false,
      },
      axisTicks: {
        show: false,
      },
    },
    yaxis: {
      show: false,
    }
  };
}

    },
  };
  </script>
  
  <style scoped>
  .card {
    box-shadow: 0 0 10px rgba(0, 0, 0, 0.05);
    border-radius: 10px;
    text-align: center;
  }
  
  h4 {
    font-size: 1.5rem;
    font-weight: bold;
  }
  
  p {
    font-size: 0.9rem;
    color: #6c757d;
  }
  </style>
  